import { API } from '@Providers';

interface SendStaffEmailVerificationPayload {
  email?: string;
}

export default async function sendStaffEmailVerificationService(
  staffId: string,
  payload: SendStaffEmailVerificationPayload = {}
) {
  const endpoint = `/api/shelter/users/${staffId}/email-verification/send`;

  return API({ endpoint, method: 'post', payload });
}
